import { get } from 'lodash'

import messages from '@/components/Form/AudienceTargeting/messages'
import { useAppSelector } from '@/store/hooks'
import { defineRule } from '@/utilities/AudienceTarget/defineRule'
import { getTargetingAggregateAttributes } from '@/utilities/UserUtilities/selectors'

const getRuleText = (filters: any, targetingAggregates: any, title: any, rulePrefixText: any) => {
  const mappedFilters = filters.map((filter: any) => {
    const value = get(filter, 'value')
    const displayValue = get(filter, 'ruleTextDisplayValue') || get(filter, 'displayValue')
    return {
      audienceType: get(filter, 'attribute.scimAttributeName'),
      audienceValue: value ? `${value}` : undefined, // Map to string
      audienceDisplayValue: displayValue,
      expressionOperator: get(filter, 'operator'), // ne/eq
      logicalOperator: 'and' // Leftover
    }
  })
  return defineRule(title, mappedFilters, targetingAggregates, rulePrefixText)
}

/**
 * @param {object} param0
 * @param {object[]} param0.filters
 */
const RuleText = ({ filters, title, rulePrefixText }: { filters: any; title: string; rulePrefixText: string }) => {
  const aggregateAttributes = useAppSelector(getTargetingAggregateAttributes)
  const ruleText = getRuleText(filters, aggregateAttributes, title, rulePrefixText)

  return (
    <div className="targeting-rule mt-2">
      <div className="rule-title">{ruleText && messages.ruleDefinition.defaultMessage}</div>
      <div className="rule-text text-zinc-950 text-sm font-normal">{ruleText}</div>
    </div>
  )
}

RuleText.displayName = 'RuleText'

export default RuleText
